module.exports = __webpack_public_path__ + "img/traffic-junction-4.eaaf1436.webp";